import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, of, throwError } from 'rxjs';
import { ModifyTypeWizardDataService } from 'src/app/services/wizards/modify-types-wizard.service';
import { ModifyTypeWizardActions } from '.';

@Injectable()
export class ModifyTypeWizardEffects {
  newModifyAssetTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ModifyTypeWizardActions.createNewModifyType),
      concatMap(({ request, typeKind, entityKind }) =>
        this.modifyTypeWizardDataService.typeModificationUpdate(request, typeKind, entityKind).pipe(
          map((response) => {
            if (response) {
              return ModifyTypeWizardActions.createNewModifyTypeSuccess({
                response: response.data,
              });
            } else {
              throwError('No data received');
            }
          }),
          catchError((error) => {
            let errorMessage = '';
            if (error instanceof HttpErrorResponse) {
              errorMessage = error.error.errorKey;
            } else {
              errorMessage = error;
            }
            return of(ModifyTypeWizardActions.createNewModifyTypeFail({ errorMessage }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private modifyTypeWizardDataService: ModifyTypeWizardDataService,
  ) {}
}
